<div class="chat-response chat-response-visualization">
  <div class="chat-visualization-summary">
    <span class="chat-response-label">{{ 'CHAT_AI.VISUALIZATION' | translate }}</span>
  </div>

  <div class="chat-visualization-list" *ngIf="visualizationBlocks.length; else visualizationTableOnly">
    <div class="chat-visualization-card" *ngFor="let block of visualizationBlocks; let blockIndex = index">
      <div class="chat-visualization-card-header">
        <span>{{ block.spec.title }}</span>
        <button *ngIf="block.chart" type="button" class="chat-download-button chat-download-chart"
          [title]="'CHAT_AI.DOWNLOAD_CHART_IMAGE' | translate"
          [attr.aria-label]="'CHAT_AI.DOWNLOAD_CHART_IMAGE' | translate"
          (click)="downloadChartImage(blockIndex, block.spec.title)">
          <mat-icon svgIcon="chat-download"></mat-icon>
        </button>
      </div>

      <span class="chat-chart-type" *ngIf="block.spec.chart_type !== 'none'">
        {{ formatChartType(block.spec.chart_type) }}
      </span>

      <div class="chat-chart-wrap" *ngIf="block.chart">
        <canvas baseChart [type]="block.chart.type" [data]="block.chart.data" [options]="block.chart.options">
        </canvas>
      </div>

      <div class="chat-map-wrap" *ngIf="block.map">
        <google-map [center]="block.map.center" [zoom]="block.map.zoom" [options]="mapOptions" height="100%"
          width="100%" (mapInitialized)="fitMapBounds($event, block.map)">
          <map-polyline *ngFor="let connection of block.map.connections" [path]="connection.path"
            [options]="connection.options">
          </map-polyline>
          <map-marker #markerRef="mapMarker" *ngFor="let marker of block.map.markers" [position]="marker.position"
            [title]="marker.title" [options]="marker.options"
            (mapClick)="openMapMarker(infoWindow, markerRef, block.map, marker)">
          </map-marker>
          <map-info-window #infoWindow="mapInfoWindow">
            <div class="chat-map-info" *ngIf="block.map.activeMarker as activeMarker">
              <div class="chat-map-info-title">{{ activeMarker.title }}</div>
              <div class="chat-map-info-row" *ngFor="let detail of activeMarker.details">
                <span class="chat-map-info-label">{{ detail.label }}</span>
                <span class="chat-map-info-value">{{ detail.value }}</span>
              </div>
            </div>
          </map-info-window>
        </google-map>
      </div>

      <div class="chat-map-legend" *ngIf="block.map?.legend?.length">
        <span class="chat-map-legend-entry" *ngFor="let entry of block.map!.legend">
          <span class="chat-map-legend-swatch" [style.background]="entry.color"></span>{{ entry.label }}
        </span>
      </div>

      <div class="chat-visualization-note" *ngIf="!block.chart && !block.map">
        {{ block.error || ('CHAT_AI.NO_CHART' | translate) }}
      </div>

      <div class="chat-visualization-note" *ngIf="block.map?.unmappedRowCount">
        {{ 'CHAT_AI.MAP_UNMAPPED_ROWS' | translate: { rows: block.map!.unmappedRowCount } }}
      </div>

      <div class="chat-visualization-meta" *ngIf="!block.isMap">
        <span *ngIf="block.spec.dataset.x">{{ 'CHAT_AI.DATASET_X' | translate }}: {{ block.spec.dataset.x }}</span>
        <span *ngIf="block.spec.dataset.y.length">{{ 'CHAT_AI.DATASET_Y' | translate }}: {{ block.spec.dataset.y.join(', ') }}</span>
        <span *ngIf="block.spec.dataset.series">{{ 'CHAT_AI.DATASET_SERIES' | translate }}: {{ block.spec.dataset.series }}</span>
      </div>

      <div class="chat-table-preview" *ngIf="block.table.columns.length && block.table.rows.length">
        <div class="chat-table-actions">
          <button type="button" class="chat-download-button chat-download-csv"
            [title]="'CHAT_AI.DOWNLOAD_CSV' | translate" [attr.aria-label]="'CHAT_AI.DOWNLOAD_CSV' | translate"
            (click)="downloadCsv(block.table, block.spec.title)">
            <mat-icon svgIcon="chat-download"></mat-icon>
          </button>
        </div>
        <table>
          <thead>
            <tr>
              <th *ngFor="let column of block.table.columns">{{ column }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of block.table.rows">
              <td *ngFor="let value of row" [class.num]="isNumericLike(value)">{{ formatCell(value) }}</td>
            </tr>
          </tbody>
        </table>
        <div class="chat-table-meta">
          {{ 'CHAT_AI.TABLE_META' | translate: { rows: block.table.rows.length, columns: block.table.columns.length } }}
        </div>
      </div>
    </div>
  </div>

  <ng-template #visualizationTableOnly>
    <div class="chat-table-preview" *ngIf="response.data.table.columns.length && response.data.table.rows.length">
      <div class="chat-table-actions">
        <button type="button" class="chat-download-button chat-download-csv"
          [title]="'CHAT_AI.DOWNLOAD_CSV' | translate" [attr.aria-label]="'CHAT_AI.DOWNLOAD_CSV' | translate"
          (click)="downloadCsv(response.data.table)">
          <mat-icon svgIcon="chat-download"></mat-icon>
        </button>
      </div>
      <table>
        <thead>
          <tr>
            <th *ngFor="let column of response.data.table.columns">{{ column }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of response.data.table.rows">
            <td *ngFor="let value of row" [class.num]="isNumericLike(value)">{{ formatCell(value) }}</td>
          </tr>
        </tbody>
      </table>
      <div class="chat-table-meta">
        {{ 'CHAT_AI.TABLE_META' | translate: { rows: response.data.table.rows.length, columns: response.data.table.columns.length } }}
      </div>
    </div>
  </ng-template>
</div>
